import { useContext } from "react";
import DashboardContext from "../dashboardContext";

/**
 * Wraps our constructed context object to ensure we're able query it within the component hierachy
 * @returns custom hook for checking for the presence of a auth token
 */
export const useDashboardContext = () => {
  const context = useContext(DashboardContext);
  return context;
};
